import { PlusIcon } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

import { AddOrganisationForm } from "./add-organisation.form";

export function AddOrganisationModal() {
  const [isCreateOrganisationModalOpen, setIsCreateOrganisationModalOpen] =
    useState(false);

  return (
    <Dialog
      open={isCreateOrganisationModalOpen}
      onOpenChange={setIsCreateOrganisationModalOpen}
    >
      <DialogTrigger asChild>
        <Button>
          <PlusIcon className="mr-1 size-4 text-inherit" /> Add Organisation
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Add Organisation</DialogTitle>
          <DialogDescription>
            Enter details required to add a new organisation
          </DialogDescription>
        </DialogHeader>
        <AddOrganisationForm
          onClose={() => setIsCreateOrganisationModalOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
